import { get, isUndefined } from 'lodash'

import types from './types'

export { default as actions } from './actions'

export const INITIAL_STATE = {}

export default (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case types.UPDATE_SAVED_CAREERS_SEARCH:
      return action.payload
    case types.CLEAR_SAVED_CAREERS_SEARCH:
      return action.payload
    default:
      return state
  }
}

export const selectSavedCareerSearch = (store) => {
  const persistedSearch = get(store, 'savedCareerSearch.query')
  if (!isUndefined(persistedSearch)) {
    return persistedSearch
  }
  return get(store, 'user.record.SavedCareerSearch')
}
